import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    loadingLandingPage: true,
    landingPage: null,
    landingPageNotFound: false,
};
export var landingPages = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
